<template>
	<v-app
		style="margin-top: -20px; margin-bottom: -20px;"
		sticky-container
		fluid
	>
		<v-row>
			<co-header></co-header>
		</v-row>
		<v-content class="content mx-auto">
			<router-view />
		</v-content>
		<v-row>
			<co-footer></co-footer>
		</v-row>
	</v-app>
</template>
<script>
import CoFooter from './components/footer.vue';
import CoHeader from './components/header.vue';

export default {
	created() {
		this.$store.dispatch('fetchClientDetails');
	},
	components: {
		CoFooter,
		CoHeader
	}
};
</script>
<style lang="scss">
.v-application--wrap {
	min-height: 0 !important;
}

.content {
	max-width: 988px !important;
	width: 100%;
}
</style>
